import { SharedSentryInitOptions } from '@pickleballinc/config/sentry-next';

import { publicEnv, serverEnv } from '@/lib/env';

export const SENTRY_CONFIG: SharedSentryInitOptions = {
  app: 'pickleball',
  sentryConfig: {
    dsn: publicEnv.NEXT_PUBLIC_SENTRY_DSN,
    debug: serverEnv.SENTRY_DEBUG,
    sampleRate: serverEnv.SENTRY_SAMPLE_RATE,
    tracesSampleRate: serverEnv.SENTRY_TRACES_SAMPLE_RATE,
  },
};
